import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { GridRow, GridCol } from '../grid/'
import InfoText from '../texts/info-text'
import Indicator from '../texts/indicator'
import AutomaticBidCtaButton from '../buttons/AutomaticBidCtaButton'
import BidCtaButton from '../buttons/BidCtaButton'
import SaveCtaButton from '../buttons/SaveCtaButton'

const ActionBoxItem = props => {
  const {
    className,
    item,
    hasAutomaticBidButton,
    hasBidButton,
    hasSaveButton,
    itemCountdownText,
    bidLabelText,
    currencyIconText
  } = props

  return (
    <div className={classNames('action-box ', className)}>
      <GridRow>
        <GridCol type='one-whole'>
          <InfoText>{itemCountdownText}</InfoText>
        </GridCol>
        <GridCol type='one-half'>
          <Indicator
            isLoud
            labelText={bidLabelText}
            smallText={currencyIconText}
            titleText={item.currentBidAmount || item.initialBid}
          />
        </GridCol>
        <GridCol type='one-half pull-right'>
          {hasAutomaticBidButton && <AutomaticBidCtaButton />}
          {hasBidButton && <BidCtaButton id={item.id} />}
          {hasSaveButton && <SaveCtaButton isSaved={false} />}
        </GridCol>
      </GridRow>
    </div>
  )
}

ActionBoxItem.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    id: PropTypes.number,
    currentBidAmount: PropTypes.number,
    initialBid: PropTypes.number
  }),
  hasAutomaticBidButton: PropTypes.bool,
  hasBidButton: PropTypes.bool.isRequired,
  hasSaveButton: PropTypes.bool.isRequired,
  itemCountdownText: PropTypes.string.isRequired,
  bidLabelText: PropTypes.string.isRequired,
  currencyIconText: PropTypes.string.isRequired
}

export default ActionBoxItem



// WEBPACK FOOTER //
// ./src/ui/boxes/action-box-item.js